export default "__VITE_ASSET__74e6c97a__"